// src/services/api/orderReference.js
import { apiClient } from './base';

export const getAllOrderReferenceData = async () => {
  try {
    const response = await apiClient.get('/order-reference/all');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOrderStatuses = async (params = {}) => {
  try {
    const response = await apiClient.get('/order-reference/order-statuses', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOrderStatusReasons = async (statusKey = null) => {
  try {
    const params = statusKey ? { statusKey } : {};
    const response = await apiClient.get('/order-reference/order-status-reasons', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPaymentTypes = async () => {
  try {
    const response = await apiClient.get('/order-reference/payment-types');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPaymentMethods = async () => {
  try {
    const response = await apiClient.get('/order-reference/payment-methods');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getReplacementReasons = async () => {
  try {
    const response = await apiClient.get('/order-reference/replacement-reasons');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCities = async (params = {}) => {
  try {
    const response = await apiClient.get('/order-reference/cities', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLocationHierarchy = async () => {
  try {
    const response = await apiClient.get('/order-reference/location-hierarchy');
    return response.data;
  } catch (error) {
    throw error;
  }
};